import React, { useState, useRef, useEffect, useCallback } from "react";
import YearlyAnalysisGrid from "./Grids/YearlyAnalysisGrid";
// import courseData from './mockData.json';
import ReportsFilter from "./ReportsFilter";
// import Year from '../Calendar/Year';

const YearlyAnalysis = () => {
    const [selectedYear, setSelectedYear] = useState();
    const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code");

    const handleCustomerCodeChange = (custCode) => {
        setSelectedCustomerCodeInfo(custCode);
    }

    const handleYearChange = (year) => {
        setSelectedYear(year);
    }

    const handleAddTraining = () => {
        setShowTrainingForm(true);
    }

    return (
        <>
            <div className="w-full sm:w-12/12 px-28 py-8">
                <ReportsFilter handleAddTraining={handleAddTraining} handleYearChange={handleYearChange} hideForecastButton={true} hideAddButton={false} handleCustomerCodeChange={handleCustomerCodeChange} />
            </div>
            <div className="grid grid-cols-2 gap-16 px-24 pb-8">
                <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#8B6392", textAlign: "center" }}>
                    <h4>2021</h4>
                    <YearlyAnalysisGrid year={true} />
                </div>
                <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#729263", textAlign: "center" }}>
                    <h4>SUMMARY-2020</h4>
                    <YearlyAnalysisGrid year={false} />
                </div>
                <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#613527", textAlign: "center" }}>
                    <h4>SUMMARY-2019</h4>
                    <YearlyAnalysisGrid year={false} />
                </div>
                <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#705D2E", textAlign: "center" }}>
                    <h4>SUMMARY-2018</h4>
                    <YearlyAnalysisGrid year={false} />
                </div>
            </div>
            {/* <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div> */}
        </>
    )
}

export default YearlyAnalysis;